<template>
  <header class="navbar">

    <div class="test-logo-and-name">
      <div>
        <a>
          <div class="logo">
            <img src="../assets/icon.svg" alt="HeadStart" />
          </div>
        </a>
      </div>

      <div>
        <span class="test-name">{{ $store.state.test.name }}</span>
      </div>

      <!-- Header for FAQs -->
      <div v-if="$route.name === 'faq'">
        <span class="test-name">Frequently Asked Questions (FAQs)</span>
      </div>
    </div>

    <!-- Header while reading Test instructions & filling details-->
      <div
        v-if="
          $route.name !== 'questions' &&
            $route.name !== 'feedback' &&
            $route.name !== 'practice-test' &&
            $route.name !== 'error' &&
            $route.name !== 'summary-page' &&
            $route.name !== 'faq' &&
            $route.name !== 'test-rules-violated'
        "
        class="wrap"
      >
        <div class="links">

          <div class="dot">
            <img
              v-if="$route.name === 'webcam'"
              src="../assets/pass_symbol.svg"
              alt="1"
              style="height:15px;"
            />
            <img
              v-else-if="$route.name === 'screenshot' || $route.name === 'fill-details-dynamic' || $route.name === 'read-instructions'"
              src="../assets/pass.svg"
              alt="1"
              style="height:15px;" />
            <img
              v-else
              src="../assets/to_pass.svg"
              alt="1"
              style="height:15px;" />
            <span :class="{ 'completed-step': $route.name !== 'webcam' }">Webcam & Mic</span>
          </div>

          <div v-if="$store.state.testeeStatus !== 'CRASHED' && $store.state.testeeStatus !== 'AUTO_CRASHED'" class="dot">
            <img
              v-if="$route.name === 'screenshot'"
              src="../assets/pass_symbol.svg"
              alt="1"
              style="height:15px;" />
            <img
              v-else-if="$route.name === 'fill-details-dynamic' || $route.name === 'read-instructions'"
              src="../assets/pass.svg"
              alt="1"
              style="height:15px;" />
            <img
              v-else
              src="../assets/to_pass.svg"
              alt="1"
              style="height:15px;" />
            <span :class="{'completed-step': $route.name === 'fill-details-dynamic' || $route.name === 'read-instructions',}">Authentication</span>
          </div>

          <div v-if="$store.state.testeeStatus !== 'CRASHED' && $store.state.testeeStatus !== 'AUTO_CRASHED'" class="dot">
            <img
              v-if="$route.name === 'fill-details-dynamic'"
              src="../assets/pass_symbol.svg"
              alt="1"
              style="height:15px;" />
            <img
              v-else-if="$route.name === 'read-instructions'"
              src="../assets/pass.svg"
              alt="1"
              style="height:15px;" />
            <img
              v-else
              src="../assets/to_pass.svg"
              alt="1"
              style="height:15px;" />
            <span :class="{'completed-step': $route.name === 'read-instructions',}">Fill your Details</span>
          </div>

          <div v-if="$store.state.testeeStatus !== 'CRASHED' && $store.state.testeeStatus !== 'AUTO_CRASHED'" class="dot">
            <img
              v-if="$route.name === 'read-instructions'"
              src="../assets/pass_symbol.svg"
              alt="1"
              style="height:15px;" />
            <img v-else src="../assets/to_pass.svg" alt="1" style="height:15px;" />
            <span>Give Test</span>
          </div>
          <div v-else class="dot" style="margin-left: 275px;">
            <img
              v-if="$route.name === 'read-instructions'"
              src="../assets/pass_symbol.svg"
              alt="1"
              style="height:15px;" />
            <img v-else src="../assets/to_pass.svg" alt="1" style="height:15px;" />
            <span>Resume Test</span>
          </div>
        </div>
      </div>
    <!-- </div> -->

    <div class="time-username-endtest">
      <!-- Header while giving the Test -->
      <div v-if="$store.state.testeeStatus !== 'COMPLETED' && ($route.name == 'practice-test' || $route.name == 'questions')">
        <div class="timerHead">

          <div class="img">
            <img v-if="this.durationLeft >= 900" src="../assets/timer_blue.svg" />
            <img v-else src="../assets/timer_red.svg" />
          </div>

          <div
            class="time"
            :class="this.durationLeft >= 900 ? 'blackTime' : 'redTime'"
          > {{ getDurationLeft }} </div>
          <div class="minLeft">min left</div>

        </div>
      </div>

      <div class="user-profile">
        <span id="user-email-span">{{ this.$store.state.userEmail }}</span>
      </div>

      <!-- End Test Button -->
      <div v-if="$store.state.testeeStatus !== 'COMPLETED' && ($route.name == 'practice-test' || $route.name == 'questions')"
        class="endtest">
        <div id="endtest-button">
          <div class="end-test-text" @click="endTestHeader">
            <span
              v-if="$route.name == 'questions'"
              style="margin: auto 0 auto 8px; min-width: 64px">END TEST</span>
            <span v-else style="margin: auto 0 auto 8px;">END PRACTICE TEST</span>
            <img
              alt="close"
              style="margin-left:10px;"
              src="../assets/Cross_Symbol.svg" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'TheHeader',
  data() {
    return {
      test_name: '',
    }
  },
  computed: {
    ...mapState({
      durationLeft: state => state.test.durationLeft,
    }),
    ...mapGetters(['getDurationLeft']),
  },
  methods: {
    ...mapActions(['startClock', 'endTest']),
    endTestHeader() {
      if (this.$route.name === 'practice-test') {
        window.close()
      } else {
        this.$store.state.showPopup = true
      }
    },
  },
}
</script>

<style scoped>
.minLeft {
  margin-top: 15px;
  margin-left: 11px;
  margin-right: 9px;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #000000;
  text-align: center;
}
.time {
  margin-left: 17px;
  margin-top: 10px;
  font-family: Roboto-Medium;
  font-size: 18px;
  color: #000000;
  text-align: center;
}
.blackTime {
  color: #000000;
}
.redTime {
  color: #f66957;
}
.img {
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 8px;
}
.timerHead {
  margin-right: 16px;
  height: 40px;
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  background: #efeef3;
  border-radius: 2px;
}

.navbar {
  display: flex;
  background: #18202f;
  height: 64px;
  color: #e1f5fe;
  position: fixed;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.navbar .dot {
  color: #69758b;
}

.test-name {
  font-family: Roboto-Regular;
  font-size: 14px;
}

.test-logo-and-name {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: 1%;
}

.wrap {
  display: flex;
  text-align: center;
  position: relative;
  font-size: 12px;
}

.links {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 28px;
}

.wrap:before {
  content: '';
  position: absolute;
  top: 8px;
  left: 35px;
  border-top: 1px solid #69758b;
  transform: translateY(-50%);
  width: 85%;
}

.dot {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 1;
}

.dot span {
  margin-top: 6px;
}

.time-username-endtest {
  display: flex;
}

.navbar .user-profile {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 16px;
  font-family: Roboto-Regular;
  letter-spacing: 0;
}

.completed-step {
  font-family: Roboto-Medium;
  font-size: 12px;
  color: #ffffff;
}

#user-email-span {
  line-height: 64px;
  vertical-align: middle;
  font-family: Roboto-Regular;
  letter-spacing: 0;
  font-size: 14px;
}

#endtest-button {
  margin: auto 16px;
  background: #f66957;
  border-radius: 2px;
  width: fit-content;
  height: 30px;
  color: white;
  padding-right: 8px;
}

.end-test-text {
  cursor: pointer;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  height: 30px;
}

.end-test-text span {
  margin-left: 10px;
}

.endtest {
  display: flex;
}
</style>
